import * as types from 'store/modules/hres63u/mutation-types'
import hres63u from 'api/hres63u'
import swal from 'sweetalert'
import hres63uLabels from 'assets/labels/hres63u'
import { hres63uColumns } from 'assets/columns/hres63u'
import configLabel from 'src/../config/label'
import { sendApprove } from 'assets/js/sendApprove.js'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hres63uLabels,
    columns: hres63uColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {},
      tab2: {},
      tab3: {
        detail: {},
        table: {
          total: 0,
          rows: []
        }
      }
    },
    indexSelected: []
  },
  getters: {
    [types.GET_HRES63U_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRES63U_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRES63U_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES63U_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES63U_INDEX] (state) {
      return state.index
    },
    [types.GET_HRES63U_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRES63U_DETAIL] (state) {
      return state.detail
    }
  },
  mutations: {
    [types.SET_HRES63U_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRES63U_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRES63U_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].detailTab3 = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab3, labels[keyLang])
      }
    },
    [types.SET_HRES63U_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES63U_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRES63U_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRES63U_DETAIL] (state, data) {
      state.detail = data
    }
  },
  actions: {
    [types.TOGGLE_HRES63U_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRES63U_INDEX_DISP, indexDisp)
      commit(types.SET_HRES63U_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRES63U_COLUMNS_LABELS] ({ commit }) {
      hres63u.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES63U_COLUMNS, data.labels)
          commit(types.SET_HRES63U_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES63U_INDEX] ({ commit }, searchParams) {
      hres63u.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          for (var i = 0; i < data.rows.length; i++) {
            data.rows[i].staappr = ''
          }
          commit(types.SET_HRES63U_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES63U_DETAIL] ({ commit }, searchParams) {
      hres63u.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES63U_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRES63U_SEND_APPROVE] ({ commit, dispatch }, indexRows) {
      sendApprove({
        dataRows: indexRows,
        sendApprove: hres63u.postSendApprove,
        dispatch: dispatch,
        dispatchType: types.RECEIVED_HRES63U_INDEX
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres63u/index.js